import { ToolRequest } from "@models/toolRequests.model";

export class ToolProcessingEntry {
    public title: string;
    public subTitle: string;
    public extra: string;
    public iconLabel: string;
    public icon: string;
    public payload: any;

    constructor(entry: any = {}) {
        this.title = entry.title || '';
        this.subTitle = entry.subTitle || '';
        this.extra = entry.extra || '';
        this.iconLabel = entry.iconLabel || '';
        this.icon = entry.icon || '';
        this.payload = entry.payload || null;
    }

    get type() {
        return 'listbox-option';
    }

}
